import React from "react";
import { useState, useRef, useMemo, useEffect } from "react";
import {
    Box, Typography, Avatar, Chip, Button, IconButton, Grid, TextField,
    Stack, Popper, Grow, Paper, ClickAwayListener, Tabs, Tab, Menu, MenuItem
} from "@mui/material";
import moment from "moment";
import TableComponent from "components/grid";
import StatusBadge from "components/badge/StatusBadge";
import CustomPagination from "components/CustomPagination";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { LuEye, LuRefreshCw, LuSearch } from "react-icons/lu";
import { BiListUl } from "react-icons/bi";
import { MdOutlineFileDownload, MdOutlineFilterAlt } from "react-icons/md";
import Select from "react-select";
import { useLazyGetAllCompliancesQuery, useLazyGetSingleComplianceDetailsQuery, useLazyGetExportAllCompliancesQuery } from "store/slices/apis/compliancesSlices";
import { useParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ViewCompliance from "./viewCompliance";
import EditComplianceTracker from "./editCompliance";
import { Category } from "@mui/icons-material";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";
import { usePermission } from "hooks/usePermission";
import { COMPLIANCE_EDIT, COMPLIANCE_VIEW } from "helpers/permissionConfig";
import { DEFAULT_DATE_FORMAT } from "config";
import useExcelExport from "hooks/useExcelExport";

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);



const actionStatusOptions = [
    { label: "Obligation Concessionair ", value: "Obligation Concessionaire" },
    { label: "Obligation Authority", value: "Obligation Authority" },
    { label: "Obligation IE", value: "Obligation IE" },
];

const ObligationConcessionaireList = () => {
    const { projectId } = useParams()

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [open, setOpen] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const anchorRef = useRef(null);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('createdDate');
    const [isEdit, setIsEdit] = useState(false)
    const [selectedData, setSelectedData] = useState(null)
    const [isView, setIsView] = useState(false)
    const [viewData, setViewData] = useState(null)
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const editAccess = usePermission(COMPLIANCE_EDIT);
    const viewAccess = usePermission(COMPLIANCE_VIEW);

    const [trigger, { data: complianceList, isFetching }] = useLazyGetAllCompliancesQuery()
    const [getComplianceById, { data: complianceByIdData, isLoading: isComplianceByIdLoading }] = useLazyGetSingleComplianceDetailsQuery();

    const module = "Compliance";

    const { data: complianceStatusRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: projectId });
    const complianceStatusData = complianceStatusRes?.data || [];
    const complianceStatus = (complianceStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: frequencyOptionsRes } = useGetMasterDataQuery({ module: module, category: 'Frequency', ProjectId: projectId });
    const frequencyOptionsData = frequencyOptionsRes?.data || [];
    const frequencyOptions = (frequencyOptionsData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: obligationsTypesRes } = useGetMasterDataQuery({ module: module, category: 'TypeOfObligation', ProjectId: projectId });
    const obligationsTypesData = obligationsTypesRes?.data || [];
    const obligationsTypes = mapAndSortAlphabetically(obligationsTypesData);

    const [filters, setFilters] = useState({
        SortBy: orderBy,
        SortOrder: order,
        PageNumber: currentPage,
        PageSize: pageSize,
        ProjectId: projectId,
        Category: "Obligation Concessionaire",
        SearchTerm: ""
    });

    const { handleExport, isExporting } = useExcelExport({ exportHook: useLazyGetExportAllCompliancesQuery, fileName: "Compliance_ObligationConcessionaire_Tracker_Data" });

    const exportComplianceObConData = (rows) =>
        rows.map((row, index) => ({
            "S.No": index + 1,
            "ID": row.customId || "-",
            "Phase": row.phase || "-",
            "Description": row.description || "-",
            "Status": row.status || "-",
            "Clause Ref": row.clauseRef || "-",
            "Page No.": row.pageNo || "-",
            "Timelines as per contract": row.timelinesAsPerContract || "-",
            "Target Date": row.targetDate && moment(row.targetDate).isValid()
                ? moment(row.targetDate).format(DEFAULT_DATE_FORMAT)
                : '-',
            "Frequency": row.frequency || "-",
            "Type of Obligation": row.typeOfObligation || "-",
        }));

    useEffect(() => {
        trigger(filters);
    }, []);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm !== filters.SearchTerm) {
                const updatedFilters = {
                    ...filters,
                    SearchTerm: searchTerm,
                    PageNumber: 1,
                };
                setFilters(updatedFilters);
                trigger(updatedFilters);
                setCurrentPage(1);
            }
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);


    const topicOptions = [
        { value: "Technical", label: "Technical" },
        { value: "Financial", label: "Financial" },
        { value: "Operational", label: "Operational" },
        { value: "Legal", label: "Legal" },
        { value: "Environmental", label: "Environmental" }
    ];


    const handleMenuOpen = (event, row) => {
        event.stopPropagation();
        setMenuAnchorEl(event.currentTarget);
        setMenuRow(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };

    const handleMenuView = () => {
        if (menuRow) {
            handleViewClick(menuRow);
        }
        handleMenuClose();
    };

    const handleMenuEdit = () => {
        if (menuRow) {
            handleEdit(menuRow);
        }
        handleMenuClose();
    };



    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const handleDelete = (filterType) => {
        const updatedFilters = {
            ...filters,
            [filterType]: "",
            PageNumber: 1
        };

        setFilters(updatedFilters);
        setTabValue(0)
        trigger(updatedFilters);
        setCurrentPage(1);
    };

    const handleSelectChange = (selectedOption, fieldName) => {
        const updatedFilters = {
            ...filters,
            [fieldName]: selectedOption?.value || "",
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setCurrentPage(1)
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;

        let utcDate = "";
        let displayValue = value;

        if (value) {
            const localDate = new Date(value);
            utcDate = localDate.toISOString();
        }

        const updatedFilters = {
            ...filters,
            [name]: utcDate,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setCurrentPage(1);
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedFilters = {
            ...filters,
            [name]: value,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
        setCurrentPage(1)
    };

    const handleReset = () => {
        const resetFilters = {
            ProjectId: projectId,
            SortBy: orderBy,
            SortOrder: order,
            PageNumber: 1,
            PageSize: 10,
            Category: "Obligation Concessionaire",
            SearchTerm: ""
        };
        setFilters(resetFilters);
        trigger(resetFilters);
        setCurrentPage(1);
        handleClose();
    };


    const handleApplyFilters = () => {
        setCurrentPage(1);
        handleClose();
        trigger(filters);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };


    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setCurrentPage(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const getAvatarColor = (title) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = title ? title.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    const createSortHandler = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        trigger(updatedFilters);
    };


    const handleEdit = async (row) => {
        try {

            const result = await getComplianceById({ complianceId: row.complianceId }).unwrap();
            setSelectedData(result.data || row);
            setIsEdit((prev) => !prev);

        } catch (error) {

            console.error('Error fetching design by ID:', error);
            setIsEdit((prev) => !prev);
            setSelectedData(row);
        }
    }

    const handleEditClose = async () => {
        setIsEdit((prev) => !prev);
        setSelectedData(null)
    }
    const handleViewClick = async (row) => {
        try {


            const result = await getComplianceById({
                complianceId: row.complianceId
            }).unwrap();

            setViewData(result?.data || row);
            setIsView(true);

        } catch (error) {
            setViewData(row);
            setIsView(true);
        }
    };


    const handleViewClose = () => {
        setIsView(false);
        setViewData(null);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const getLabel = (value) => {
        switch (value) {
            case "5": return "Expected";
            case "4": return "Highly Expected";
            case "3": return "Likely";
            case "2": return "Not Likely";
            case "1": return "Rare";
            default: return value;
        }
    };

    const highlightText = (text, highlight) => {
        if (!highlight || !text) return text;

        const regex = new RegExp(`(${highlight})`, 'gi');
        const parts = String(text).split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span
                    key={index}
                    style={{
                        backgroundColor: '#FFF3CD',
                        color: '#856404',
                        fontWeight: 'bold',
                        padding: '0 2px',
                        borderRadius: '3px'
                    }}
                >
                    {part}
                </span>
            ) : part
        );
    };


    const columns = [

        {
            name: "",
            field: "actions",
            width: "10px",
            sticky: true,
            renderer: (row) => (
                <>
                    {(viewAccess || editAccess) &&
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <IconButton
                                size="small"
                                onClick={(e) => handleMenuOpen(e, row)}
                            >
                                <MoreVertIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    }
                </>
            ),
        },
        {
            name: "ID",
            field: "customId",
            width: "70px",
            sticky: true,
        },
        {
            name: "Phase",
            field: "phase",
            width: "120px",
            sticky: true,
            renderer: (row) => (
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    maxWidth: "150px",
                }}>
                    {/* <Avatar
                        sx={{
                            width: 30,
                            height: 30,
                            bgcolor: getAvatarColor(row.topic),
                            color: "#fff",
                            fontSize: "14px",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            flexShrink: 0,
                        }}
                    >
                        {row?.phase?.[0] || "?"}
                    </Avatar> */}
                    <Box sx={{
                        wordWrap: 'break-word',
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                        maxWidth: 'calc(150px - 40px)',
                    }}>
                        {row?.phase}
                    </Box>
                </Box>
            ),
        },
        {
            name: 'Description',
            field: 'description',
            width: "300px",
            sticky: true,
            renderer: (row) => highlightText(row.description, searchTerm),
        },
        {
            name: 'Status',
            field: 'status',
            renderer: (row) => (
                <>
                    {row?.status &&
                        <StatusBadge status={row.status} />
                    }
                </>

            )
        },
        {
            name: "Clause Ref",
            field: "clauseRef",
            width: "200px",
            renderer: (row) => highlightText(row.clauseRef, searchTerm),
        },
        {
            name: "Page No.",
            field: "pageNo",
        },
        // {
        //     name: "Completion Date ",
        //     field: "completionDate",
        //     renderer: (row) => (
        //         moment(row?.completionDate).format("DD MMM YYYY")
        //     ),
        // },
        {
            name: "Timelines as per contract",
            field: "timelinesAsPerContract",
            width: '250px'
        },
        {
            name: "Target Date ",
            field: "targetDate",
            renderer: (row) => (
                moment(row?.targetDate).isValid()
                    ? moment(row?.targetDate).format("DD MMM YYYY")
                    : "-"
            ),
        },
        {
            name: "Frequency",
            field: "frequency",
        },
        {
            name: "Type of Obligation",
            field: "typeOfObligation",
        }
    ];

    return (
        <>

            <Grid size={12}>
                <Grid container spacing={1}>
                    <Grid size={{ md: 8, sm: 6 }}>
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                padding: "8px 0",
                                alignItems: "center",
                                minHeight: "40px",
                                flexWrap: "wrap",
                                gap: 1
                            }}
                        >
                            {filters.TypeOfObligation && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Type Of Obligation:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {filters.TypeOfObligation}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('TypeOfObligation')}
                                />
                            )}

                            {filters.Status && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Status:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {filters.Status}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('Status')}
                                />
                            )}

                            {filters.TargetDateFrom && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Target Date From:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {moment(filters.TargetDateFrom).format('DD-MM-YYYY')}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('TargetDateFrom')}
                                />
                            )}

                            {filters.TargetDateTo && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Target Date To:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {moment(filters.TargetDateTo).format('DD-MM-YYYY')}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('TargetDateTo')}
                                />
                            )}

                            {filters.Frequency && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Frequency:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {filters.Frequency}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('Frequency')}
                                />
                            )}
                        </Stack>
                    </Grid>
                    <Grid size={{ md: 4, sm: 6 }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: 'end',
                                p: "8px 0px"
                            }}
                        >
                            <TextField
                                placeholder="Search By Description & Clause Ref"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                variant="outlined"
                                size="small"
                                InputProps={{
                                    startAdornment: <LuSearch style={{ marginRight: '8px', color: '#6B7280' }} />,
                                }}
                                sx={{
                                    minWidth: '250px',
                                    width: "100%",
                                    backgroundColor: '#fff',
                                    '& .MuiOutlinedInput-root': { borderRadius: '3px', minHeight: '36px', fontSize: '13px' },
                                    '& .MuiInputBase-input::placeholder': {
                                        fontSize: '0.9rem',
                                    }
                                }}
                                type="search"
                            />
                            <IconButton
                                ref={anchorRef}
                                onClick={handleToggle}
                            >
                                <MdOutlineFilterAlt size={24} color="#48535B" />
                            </IconButton>
                            <Popper
                                open={open}
                                anchorEl={anchorRef.current}
                                placement="bottom-end"
                                transition
                                disablePortal={false}
                                sx={{ zIndex: 2000 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {({ TransitionProps }) => (
                                    <Grow {...TransitionProps}>
                                        <Paper
                                            sx={{
                                                mt: 1,
                                                p: 2,
                                                borderRadius: 1,
                                                boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                width: 600,
                                            }}
                                        >
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <Box>
                                                    <Grid container spacing={2}>
                                                        <Grid size={{ xs: 12, md: 6 }}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Type Of Obligation</Typography>
                                                            <Select
                                                                name="TypeOfObligation"
                                                                options={obligationsTypes}
                                                                placeholder="Select Type Obligation"
                                                                onChange={(option) => handleSelectChange(option, "TypeOfObligation")}
                                                                value={filters.TypeOfObligation ? obligationsTypes.find(option => option.value === filters.TypeOfObligation) : null}
                                                            />
                                                        </Grid>

                                                        <Grid size={{ xs: 12, md: 6 }}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Select Status</Typography>
                                                            <Select
                                                                name="Status"
                                                                options={complianceStatus}
                                                                placeholder="Select Status"
                                                                onChange={(option) => handleSelectChange(option, "Status")}
                                                                value={filters.Status ? complianceStatus.find(option => option.value === filters.Status) : null}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, md: 6 }}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Select Frequency</Typography>
                                                            <Select
                                                                name="Frequency"
                                                                options={frequencyOptions}
                                                                placeholder="Select Frequency"
                                                                onChange={(option) => handleSelectChange(option, "Frequency")}
                                                                value={filters.Frequency ? frequencyOptions.find(option => option.value === filters.Frequency) : null}
                                                            />
                                                        </Grid>


                                                        <Grid size={{ xs: 12, md: 6 }}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Target Date From</Typography>
                                                            <TextField
                                                                type="date"
                                                                name="TargetDateFrom"
                                                                value={filters.TargetDateFrom ?
                                                                    moment(filters.TargetDateFrom).format('YYYY-MM-DD') :
                                                                    ''}
                                                                onChange={handleDateChange}
                                                                onClick={(e) => {
                                                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                    if (input) input.showPicker?.();
                                                                }}
                                                                fullWidth
                                                                sx={{
                                                                    "& input::-webkit-calendar-picker-indicator": {
                                                                        display: "none",
                                                                        WebkitAppearance: "none",
                                                                    },
                                                                    "& input[type='date']": {
                                                                        appearance: "none",
                                                                        WebkitAppearance: "none",
                                                                    },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset": {
                                                                            border: "none",
                                                                        },
                                                                    },
                                                                }}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                            {calenderSVG}
                                                                        </Box>
                                                                    ),
                                                                    sx: {
                                                                        backgroundColor: "#E7E7EB",
                                                                        height: "40px",
                                                                        width: { xs: "100%", md: "100%" },
                                                                        borderRadius: "3px",
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, md: 6 }}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Target Date To</Typography>
                                                            <TextField
                                                                type="date"
                                                                name="TargetDateTo"
                                                                value={filters.TargetDateTo ?
                                                                    moment(filters.TargetDateTo).format('YYYY-MM-DD') :
                                                                    ''}
                                                                // onBlur={handleBlur}
                                                                onChange={handleDateChange}
                                                                onClick={(e) => {
                                                                    // Trigger the native date picker
                                                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                    if (input) input.showPicker?.();
                                                                }}
                                                                fullWidth
                                                                sx={{
                                                                    // ...rightTextStyle,
                                                                    "& input::-webkit-calendar-picker-indicator": {
                                                                        display: "none",
                                                                        WebkitAppearance: "none",
                                                                    },
                                                                    "& input[type='date']": {
                                                                        appearance: "none",
                                                                        WebkitAppearance: "none",
                                                                    },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset": {
                                                                            border: "none",
                                                                        },
                                                                    },
                                                                }}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                        >
                                                                            {calenderSVG}
                                                                        </Box>
                                                                    ),
                                                                    sx: {
                                                                        backgroundColor: "#E7E7EB",
                                                                        height: "40px",
                                                                        width: { xs: "100%", md: "100%" },
                                                                        borderRadius: "3px",
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid size={12}>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "flex-end",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <Button onClick={handleReset}
                                                                    sx={{
                                                                        textTransform: "none",
                                                                        color: "#F15744",
                                                                        fontSize: "14px",
                                                                        lineHeight: "100%",
                                                                        fontFamily: "Outfit, sans-serif",
                                                                        borderRadius: "3px",
                                                                        fontWeight: 500,
                                                                        px: "20px",
                                                                        py: "15px",
                                                                    }}>
                                                                    Reset
                                                                </Button>
                                                                <Button
                                                                    type="button"
                                                                    onClick={handleApplyFilters}
                                                                    variant="contained"
                                                                    sx={{
                                                                        backgroundColor: "#00344C",
                                                                        borderRadius: "3px",
                                                                        textTransform: "none",
                                                                        fontWeight: 500,
                                                                        fontSize: "14px",
                                                                        lineHeight: "100%",
                                                                        fontFamily: "Outfit, sans-serif",
                                                                        color: "#FFFFFF",
                                                                        px: "20px",
                                                                        py: "15px",
                                                                    }}
                                                                >
                                                                    Apply
                                                                </Button>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>

                            <IconButton onClick={() =>
                                handleExport(
                                    filters,
                                    exportComplianceObConData
                                )
                            } disabled={isExporting}>
                                <MdOutlineFileDownload size={24} color="#48535B" />
                            </IconButton>

                            <IconButton onClick={() => trigger(filters)}>
                                <LuRefreshCw size={20} color="#48535B" />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={12}>
                <TableComponent
                    data={complianceList?.data || []}
                    isLoading={isFetching}
                    columns={columns}
                    order={order}
                    orderBy={orderBy}
                    createSortHandler={createSortHandler}
                />

                <Menu
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleMenuClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            mt: 1,
                            borderRadius: "3px",
                            minWidth: 140,
                            border: "1px solid #E5E9EB",
                            boxShadow: "0px 10px 30px rgba(15, 23, 42, 0.12)",
                            overflow: "hidden",
                        },
                    }}
                    MenuListProps={{
                        sx: {
                            py: 0.5,
                        },
                    }}
                >
                    {viewAccess &&
                        <MenuItem
                            onClick={handleMenuView}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <LuEye size={16} style={{ color: "#4B5563" }} />
                            <span>View</span>
                        </MenuItem>
                    }

                    {editAccess &&
                        <MenuItem
                            onClick={handleMenuEdit}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <EditIcon style={{ width: 14, height: 14 }} />
                            <span>Edit</span>
                        </MenuItem>
                    }

                </Menu>
                <CustomPagination
                    totalCount={complianceList?.totalRecords}
                    pageSize={pageSize}
                    page={currentPage}
                    onPageChange={handlePageChange}
                    setCurrentPage={setCurrentPage}
                    onPageSizeChange={handlePageSizeChange}
                />
            </Grid>
            {isView && (
                <ViewCompliance
                    open={isView}
                    handleClose={handleViewClose}
                    rowData={viewData}
                    isLoading={isComplianceByIdLoading}
                />
            )}
            {isEdit && (
                <EditComplianceTracker
                    open={isEdit}
                    handleClose={handleEditClose}
                    rowData={selectedData}
                    isLoading={isComplianceByIdLoading}
                />
            )}


        </>
    );
}
export default ObligationConcessionaireList;